import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
	gap: theme.spacing(1),
	padding: theme.spacing(1, 2),
	minWidth: 180,
	fontSize: '0.875rem',
}));

export const DangerMenuItem = styled(MenuItem)(({ theme }) => ({
	gap: theme.spacing(1),
	padding: theme.spacing(1, 2),
	minWidth: 180,
	fontSize: '0.875rem',
	color: theme.palette.error.main,
	'& .MuiListItemIcon-root': {
		color: theme.palette.error.main,
	},
	'&:hover': {
		backgroundColor: theme.palette.error.light + '22',
	},
}));
